<template>
  <CForm ref="uploaimage">
    <Loading v-if="isLoading"></Loading>
    <div v-else>
      <CRow>
        <CCol sm="6">Images here</CCol>
      </CRow>
      <CRow v-if="paymentStatus === '2'">
        <CCol sm="3">
          <CInputFile
            ref="fileupload"
            label
            accept="image/*"
            invalid-feedback="Name should be filled"
            required
            @change="onFileChange"
          />

          <CInput
            :type="'hidden'"
            required
            v-model="$v.uploadImageForm.images.$model"
            :is-valid="!$v.uploadImageForm.images.$invalid"
          ></CInput>

          <CButton @click="submitForm" :disabled="$v.uploadImageForm.$invalid" color="success">
            <i class="fa fa-save"></i>
            Accept
          </CButton>&nbsp;
          <CButton @click="removeImage" color="danger">
            <i class="fa fa-remove"></i>
            Remove
          </CButton>
        </CCol>
        <CCol sm="2">
          <div>Preview :<br/></div>
          
          <CCard v-if="paymentMethods.images === null && uploadImageForm.images !== null">
             <div @click="previewForm" style="cursor:pointer">
            <CImg :src="uploadImageForm.images" :thumbnail="true" />
            </div>
          </CCard>
          <CCard v-else-if="paymentMethods.images !== null">
             <div @click="previewForm" style="cursor:pointer">
            <CImg :src="'https://storage.googleapis.com/isikulkas/'+paymentMethods.images+'?r='+unixTime" :thumbnail="true" />
            </div>
          </CCard>
          <CCard v-else>
            <CCardBody>
              <CRow>
                <div>
                <CCol sm="12">No image</CCol>
                </div>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <CRow v-else>
        <CCol sm="3">
           <div @click="previewForm" style="cursor:pointer">
          <CImg :src="'https://storage.googleapis.com/isikulkas/'+paymentMethods.images+'?r='+unixTime" :thumbnail="true" />
          </div>
        </CCol>
      </CRow>

      <CModal
      title="Image Preview"
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="preview"
    >
      <CImg :src="'https://storage.googleapis.com/isikulkas/'+paymentMethods.images+'?r='+unixTime" :thumbnail="true" />
    
    </CModal>

    </div>
  </CForm>
  
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "UploadImage",
  components: { Loading },
  data() {
    return {
      title: "Upload Image",
      items: [],
      uploadImageForm: tableInterfaces.payment_method,
      isLoading: false,
      image: null,
      activeTab: 0,
      preview: false,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0
    };
  },
  props: {
    paymentMethods: {
      type: [Array, Object],
      default: () => [],
    },
    paymentStatus: {
      type: String,
      default: null
    },
  },
  validations: {
    uploadImageForm: {
      images: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function () {
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1) ) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    submitForm: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.uploadImageForm.id = this.paymentMethods.id;

        this.axios
          .put("console/payment_method/update-image", this.uploadImageForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Product Issue",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[5]);
          });
      }
    },
    
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.uploadImageForm.images = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
       if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        var remove = {'images': this.paymentMethods.images, 'id': this.paymentMethods.id};

        this.axios
          .put("console/payment_method/remove-image", remove)
          .then((response) => {
            this.$refs.uploaimage.reset();
            this.$refs.fileupload.value = null;
            this.uploadImageForm.images = null;
            this.paymentMethods.images = null;
            //       this.showInfoNotification({
            //   title: "Ubah Product Issue",
            //   message: response.data.message,
            // });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            this.$router.go(0);
            // let route = this.$route.path.split("/");
            // this.init(route[4]);
          });
      }
      //console.log(this.products.images);
    },
  },
  mounted() {},
};
</script>
